module.exports = __webpack_public_path__ + "static/media/burp.09a1949a.png";